<template>
    <div id="sidebar" class="flex column align-center content">
      <img class="logo" src="@/assets/images/logo_black.png" />
      <router-link
        v-if="userIsCompanyType"
        @click.native="closeSidebar"
        to="/ce-recharge"
        class="link"
      >
        Recargar saldo
      </router-link>
      <router-link
        @click.native="closeSidebar"
        to="/vehicles"
        class="link"
      >
        Lista de Vehículos
      </router-link>
      <router-link
        v-if="userIsCompanyType"
        @click.native="closeSidebar"
        to="/ce-moves-list"
        class="link"
      >
        Movimientos Recientes
      </router-link>
      <router-link
        v-if="userIsNormalType"
        @click.native="closeSidebar"
        to="/moves-list"
        class="link"
      >
        Lista de Cruces
      </router-link>
      <router-link
        v-if="!userIsReporter"
        @click.native="closeSidebar"
        to="/invoiceable-sales"
        class="link"
      >
        Facturar Movimientos
      </router-link>
      <router-link
        @click.native="closeSidebar"
        to="/invoices"
        class="link"
      >
        Facturas Disponibles
      </router-link>
      <router-link
        v-if="userIsCompanyAdmin"
        @click.native="closeSidebar"
        to="/subusers"
        class="link"
      >
       Administrar Usuarios
      </router-link>
      <router-link
        @click.native="closeSidebar"
        to="/change-password"
        class="link"
      >
        Cambiar Contraseña
      </router-link>
      <a
        @click.prevent="openModal"
        class="link bottom-link"
      >
        Cerrar Sesión
      </a>
    <ConfirmationModal
      @cancel="closeModal"
      @confirm="performLogout"
      :active="showModal"
      confirm-text="Cerrar Sesión"
      message="¿Estás seguro que quieres cerrar sesión?"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfirmationModal from '@/components/ConfirmationModal'

export default {
  name: 'LoggedInSidebar',
  components: {
    ConfirmationModal
  },
  data () {
    return {
      showModal: false
    }
  },
  computed: {
    ...mapGetters('user', [
      'userIsCompanyAdmin',
      'userIsCompanyType',
      'userIsNormalType',
      'userIsReporter'
    ])
  },
  methods: {
    ...mapActions('user', [
      'logout'
    ]),
    async performLogout () {
      await this.logout()
      this.$router.push(`/?redirect=${this.$route.fullPath}`)
    },
    openModal () {
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
    closeSidebar () {
      const sidebar = document.getElementById('sidebar')

      if (sidebar.classList.contains('active')) {
        setTimeout(() => {
          sidebar.classList.remove('active')
        }, 500)
        sidebar.classList.add('inactive')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import  '@/assets/styles/constants.scss';

#sidebar {
  background-color: $white;
  width: 15%;
  height: 100vh;
  float: left;
  position: fixed;
  z-index: 1;
}

.logo {
  width: 70%;
  margin: 2.25rem 0;
}

.link {
  color: $grey;
  margin: .75rem 0rem;
  text-align: start;
  text-decoration: none;
  width: 70%;
  cursor: pointer;
}

.bottom-link {
  margin-bottom: 3rem;
  margin-top: auto;
}

@media screen and (max-width: 960px) {
  #sidebar {
    display: none;
    width: 55%;
    height: calc(100vh - 70px);
    top: 75px;
    box-shadow: 0px 0px 10px 5px #c5c5c5;

    &.active {
      display: flex;
      animation-name: slide-in;
      animation-duration: 0.5s;
    }

    &.inactive {
      animation-name: slide-out;
      animation-duration: 0.5s;
    }
  }

  @keyframes slide-in {
    from { left: -250px; }
    to { left: 0px; }
  }

  @keyframes slide-out {
    from { left: 0; }
    to {
      left: -250px;
      display: none;
    }
  }
}
</style>
